import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import PublicOffOutlinedIcon from "@mui/icons-material/PublicOffOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";

import ButtonGroup from "lib/ui/button/ButtonGroup";

import { asTitle } from "utils/Utils";

export type LibraryActionbarProps = {
	enabled: boolean;

	onMakePublic: (pub: boolean) => void;
	onImport: () => void;
};

export default function LibraryActionbar(
	props: Readonly<LibraryActionbarProps>
): JSX.Element {
	const { t } = useTranslation();

	const handleAddToLibrary = useCallback(() => {
		props.onMakePublic(true);
	}, [props.onMakePublic]);

	const handleRemoveFromLibrary = useCallback(() => {
		props.onMakePublic(false);
	}, [props.onMakePublic]);

	return (
		<ButtonGroup>
			<Tooltip title={asTitle(t("addToLibrary"))}>
				<span>
					<IconButton
						aria-label="addToLibrary"
						disabled={!props.enabled}
						onClick={handleAddToLibrary}
						size="large">
						<PublicOutlinedIcon />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title={asTitle(t("removeFromLibrary"))}>
				<span>
					<IconButton
						aria-label="removeFromLibrary"
						disabled={!props.enabled}
						onClick={handleRemoveFromLibrary}
						size="large">
						<PublicOffOutlinedIcon />
					</IconButton>
				</span>
			</Tooltip>
			<Divider orientation="vertical" flexItem />
			<Tooltip title={asTitle(t("importFromLibrary"))}>
				<IconButton
					aria-label="importFromLibrary"
					onClick={props.onImport}
					size="large">
					<BookOutlinedIcon />
				</IconButton>
			</Tooltip>
		</ButtonGroup>
	);
}
